import { render, staticRenderFns } from "./UpdateParentCompany.vue?vue&type=template&id=4d399529&scoped=true&"
import script from "./UpdateParentCompany.vue?vue&type=script&lang=js&"
export * from "./UpdateParentCompany.vue?vue&type=script&lang=js&"
import style0 from "./UpdateParentCompany.vue?vue&type=style&index=0&id=4d399529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d399529",
  null
  
)

export default component.exports